var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.33331H9.66666V0.99998C9.66666 0.823169 9.59642 0.6536 9.47139 0.528575C9.34637 0.403551 9.1768 0.333313 8.99999 0.333313C8.82318 0.333313 8.65361 0.403551 8.52858 0.528575C8.40356 0.6536 8.33332 0.823169 8.33332 0.99998V8.33331H0.999989C0.823178 8.33331 0.653609 8.40355 0.528585 8.52857C0.403561 8.6536 0.333323 8.82317 0.333323 8.99998C0.330033 9.08662 0.345354 9.17297 0.378253 9.25319C0.411152 9.33341 0.460864 9.40565 0.52404 9.46503C0.587216 9.52442 0.662388 9.56957 0.74449 9.59745C0.826591 9.62533 0.913715 9.63528 0.999989 9.62665H8.33332V17C8.33332 17.1768 8.40356 17.3464 8.52858 17.4714C8.65361 17.5964 8.82318 17.6666 8.99999 17.6666C9.1768 17.6666 9.34637 17.5964 9.47139 17.4714C9.59642 17.3464 9.66666 17.1768 9.66666 17V9.66665H17C17.1768 9.66665 17.3464 9.59641 17.4714 9.47138C17.5964 9.34636 17.6667 9.17679 17.6667 8.99998C17.6667 8.82317 17.5964 8.6536 17.4714 8.52857C17.3464 8.40355 17.1768 8.33331 17 8.33331Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3baf113cf5b2af08f3a63539bd1d7e3c.svg";
export { ForwardRef as ReactComponent };